import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    usersHeading: {
      padding: '24px 40px',
      justifyContent: 'space-between',
      background: 'transparent',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        height: 'auto'
      },
      [theme.breakpoints.only('sm')]: {
        alignItems: 'baseline',
        gap: '24px',
        padding: '24px 30px'
      },
      [theme.breakpoints.only('xs')]: {
        gap: '16px',
        justifyContent: 'center',
        padding: '16px 24px'
      }
    },
    usersText: {
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: '1',
      [theme.breakpoints.only('xs')]: {
        fontSize: '32px'
      }
    },
    userAddNewButton: {
      width: '175px',
      [theme.breakpoints.down('xs')]: {
        width: '175px',
        height: '41px'
      },
      [theme.breakpoints.only('md')]: {
        width: '175px',
        height: '45px'
      }
    },
    usersTableOuterBox: {
      flex: 1,
      minHeight: 0,
      background: 'transparent',
      padding: '0px 40px',
      overflow: 'visible',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        padding: '5px 20px 20px'
      }
    },
    usersHeadersUsertype: {
      paddingLeft: '24px',
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600
    },
    usersTableHeaders: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600
    },
    usersTableRows: {
      height: '70px',
      '&$selected': {
        borderWidth: 0,
        borderLeftWidth: 20,
        borderColor: 'black',
        borderStyle: 'solid',
        backgroundColor: 'white'
      },
      '&$selected:hover': {
        backgroundColor: 'white'
      }
    },
    selected: {},
    userRoleRow: {
      paddingLeft: '24px !important'
    },
    footer: {
      width: '100%',
      overflow: 'hidden',
      padding: '0px 40px',
      margin: 0
    },
    total: {
      float: 'right',
      fontSize: '20px',
      padding: '24px 0 0',
      fontWeight: 900,
      margin: 0
    },
    formInnerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'transparent'
    },
    formDropdownBox: {
      background: 'transparent',
      minWidth: '100%',
      height: '120px',
      [theme.breakpoints.down('xs')]: {
        height: '110px'
      },
      '& > * > *': {
        [theme.breakpoints.down('xs')]: {
          minWidth: '240px',
          width: '245px'
        }
      }
    },
    formDropdownLabel: {
      margin: '0px 0px 10px',
      fontSize: '16px',
      fontWeight: 'bold',
      paddingLeft: '16px'
    },
    formSwitchBlock: {
      display: 'flex',
      flexDirection: 'row',
      background: 'transparent',
      height: '68px',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        padding: '35px 0px 0px 21px',
        height: '14px'
      }
    },
    formInputBox: {
      background: 'transparent',
      height: '120px',
      minWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        height: '110px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    formPinBlock: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      background: 'transparent',
      minWidth: '100%',
      alignItems: 'center',
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column',
        alignItems: 'baseline'
      }
    },
    formPinInputBox: {
      height: '120px',
      marginRight: '1rem',
      [theme.breakpoints.down('sm')]: { width: '100%' },
      [theme.breakpoints.down('xs')]: {
        height: '100px',
        display: 'inline-flex',
        flexDirection: 'column'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    formButtonBox: {
      marginBottom: '.6rem',
      [theme.breakpoints.down('xs')]: {
        height: '100px',
        display: 'inline-flex',
        flexDirection: 'column',
        margin: '0rem',
        width: '100%'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '80px'
        }
      }
    },
    formButton: {
      [theme.breakpoints.down('xs')]: {
        height: '40px',
        width: '100%'
      }
    }
  })
);
